/* Smooth accordions and tabs (2026-10-22, Abid).
   Every fold-out on the site opens and closes the way the Evri tracking page does (see section 1 + 2 below):
   - product page tabs (How to buy, Returns, Delivery, and any other collapsible block), Estimate shipping, Reviews
   - footer link groups on phones, FAQ page questions
   - every <details> question list (customer care, contact, trade)
   - real tab bars ([role="tab"], e.g. the glass product page): the box glides to the new tab's height and the new tab fades in.
   This file takes over the click for those fold-outs (before theme.js or older Bull Ring code sees it), so there is one
   animation, not several fighting. Collection filters and the phone menu keep the theme's own behaviour.
   Opt out on any element with data-brf-noacc.
   2026-10-23: phones set to Reduce Motion now get a soft fade (Apple's own approach) instead of a hard snap.
   Add ?brfacc=1 to any page address to show a small label confirming this file is running (for checking on a phone). */
(function () {
  'use strict';
  if (window.__brfAcc) return;
  window.__brfAcc = 1;

  var doc = document;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var canAnim = !!(Element.prototype.animate);
  var EASE_OPEN = 'cubic-bezier(.25,.85,.3,1)';
  var EASE_FADE_IN = 'cubic-bezier(.2,.6,.3,1)';
  var TRIGGERS = [
    '[data-action="toggle-collapsible"].card__collapsible-button',
    '[data-action="toggle-collapsible"].footer__title',
    '[data-action="toggle-collapsible"].faq__question',
    '.brf-tab-toggle',
    '.brf-rev-toggle'
  ].join(',');

  function still() { return !canAnim; }
  function calm() { return mq.matches; }
  function dur(h, open) {
    if (calm()) return open ? 240 : 180;
    var d = (open ? 380 : 340) + Math.min(h, 1200) * (open ? 0.15 : 0.1);
    return Math.round(Math.min(d, open ? 560 : 460));
  }
  /* Reduce Motion: the box changes size at once and the text only fades (no glide, no slide) */
  function sizeMs(h, open) { return calm() ? 1 : dur(h, open); }
  function setI(el, prop, val) { el.style.setProperty(prop, val, 'important'); }
  function unI(el, props) { props.forEach(function (p) { el.style.removeProperty(p); }); }
  function fadeTarget(panel) {
    var kids = [].filter.call(panel.children, function (c) { return c.tagName !== 'SCRIPT' && c.tagName !== 'STYLE' && c.tagName !== 'TEMPLATE'; });
    return kids.length === 1 ? kids[0] : panel;
  }
  function stop(panel) {
    var r = panel.__brfAccRun;
    if (r) { r.forEach(function (a) { try { a.cancel(); } catch (e) {} }); panel.__brfAccRun = null; }
  }
  function curH(el) { return el.getBoundingClientRect().height; }
  var LAYOUT = ['height', 'padding-top', 'padding-bottom', 'box-sizing', 'overflow', 'display', 'visibility'];

  /* ---------- 1 + 2. Fold-outs, the Evri way (2026-10-23) ----------
     Measured from Abid's screen recording of the Evri tracking page: the opened text is laid out at once and fades in
     within ~0.15s, and everything BELOW it slides down (or back up) with a smooth ~0.45s ease, passing over the text.
     So here the page underneath moves with transform (smooth on phones, no re-layout every frame) instead of the
     box growing. Closing: the text fades while the rows below slide back up over it, then the box folds away. */
  var EASE_SLIDE = 'cubic-bezier(.4,0,.2,1)';
  function slideMs(dist) { return Math.round(360 + Math.min(Math.abs(dist), 600) * 0.15); }
  /* closing is slower and softer than opening, so the text melts away rather than snapping shut (2026-10-23, Abid) */
  var CLOSE_SLOW = 1.4;
  /* and it eases in gently, so the card holds open a beat while the text starts to fade, then folds */
  var EASE_FOLD = 'cubic-bezier(.55,0,.35,1)';
  function moveMs(dist, endOff) { return Math.round(slideMs(dist) * (endOff ? CLOSE_SLOW : 1)); }
  function moveable(el) {
    if (!el || el.nodeType !== 1 || /^(SCRIPT|STYLE|LINK|TEMPLATE|META|NOSCRIPT)$/.test(el.tagName) || el.hasAttribute('data-brf-acc-badge')) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.position !== 'fixed' && cs.position !== 'sticky';
  }
  /* everything after the fold-out on the page: its later siblings, its parent's later siblings, and so on up to <body> */
  function followersOf(item) {
    var out = [], node = item;
    while (node && node !== doc.body && node !== doc.documentElement && out.length < 80) {
      for (var s = node.nextElementSibling; s && out.length < 80; s = s.nextElementSibling) if (moveable(s)) out.push(s);
      node = node.parentElement;
    }
    return out;
  }
  function tops(list) { return list.map(function (el) { return el.getBoundingClientRect().top; }); }
  function opacityOf(el) { return parseFloat(getComputedStyle(el).opacity) || 0; }
  function cancelAll(st) {
    if (!st) return;
    (st.runs || []).forEach(function (a) { try { a.cancel(); } catch (e) {} });
    st.runs = [];
  }
  function anchorOff(on) { doc.documentElement.style.overflowAnchor = on ? 'none' : ''; }

  /* slide each follower from where it is on screen now (before) to where the new layout puts it, plus endOff */
  function slide(list, before, endOff) {
    var after = tops(list), cap = Math.max(240, (window.innerHeight || 800) * 0.9), runs = [];
    list.forEach(function (el, i) {
      var start = before[i] - after[i];
      if (Math.abs(endOff - start) > cap) start = endOff + (start > endOff ? cap : -cap);
      if (i === 0) runs.first = { start: start, end: endOff };
      if (Math.abs(endOff - start) < 1) return;
      runs.push(el.animate([{ transform: 'translateY(' + start + 'px)' }, { transform: 'translateY(' + endOff + 'px)' }],
        { duration: moveMs(endOff - start, endOff), easing: endOff ? EASE_FOLD : EASE_SLIDE, fill: endOff ? 'forwards' : 'none' }));
    });
    return runs;
  }
  /* the opened card's own bottom edge travels with the card below it, so its text never shows in the gaps between
     the floating glass cards (Evri's rows sit in one white panel, so there it can't) */
  function clipWith(item, first) {
    if (!first || Math.abs(first.end - first.start) < 1) return null;
    var r = parseFloat(getComputedStyle(item.querySelector(':scope > .card') || item).borderBottomLeftRadius) || 0;
    var shape = function (b) { return 'inset(-60px -2px ' + b + 'px -2px round 0 0 ' + r + 'px ' + r + 'px)'; };
    return item.animate([{ clipPath: shape(-first.start) }, { clipPath: shape(-first.end) }],
      { duration: moveMs(first.end - first.start, first.end), easing: first.end ? EASE_FOLD : EASE_SLIDE, fill: first.end ? 'forwards' : 'none' });
  }

  /* one engine for theme collapsibles, Bull Ring tab toggles and <details> */
  function fold(o) {
    /* o: { key, item, opening, applyOpen(), applyClosed(), holdOpen(), fadeEls[] }
       holdOpen: the header already shows "closed" (chevron turns at once, like Evri) while the text stays on screen */
    var st = o.key.__brfAcc || (o.key.__brfAcc = {});
    var list = followersOf(o.item);
    var before = tops(list);
    var fades = o.fadeEls.map(opacityOf);
    var wasClosing = st.closing;
    cancelAll(st);
    st.closing = false;
    anchorOff(true);

    if (o.opening) {
      o.applyOpen();
      if (still()) { anchorOff(false); return; }
      var runs = calm() ? [] : slide(list, before, 0);
      var c1 = calm() ? null : clipWith(o.item, runs.first);
      if (c1) runs.push(c1);
      o.fadeEls.forEach(function (el, i) {
        /* 2026-10-25: fade-in lengthened from 0.16s to 0.4s so the text visibly fades in as the rows below slide down */
        runs.push(el.animate([{ opacity: wasClosing ? fades[i] : 0 }, { opacity: 1 }], { duration: calm() ? 320 : 400, easing: EASE_FADE_IN }));
      });
      st.runs = runs;
      var last = runs.reduce(function (a, b) { return (b.effect.getComputedTiming().endTime > (a ? a.effect.getComputedTiming().endTime : -1)) ? b : a; }, null);
      var opened = function () { if (st.runs.indexOf(last) > -1) { st.runs = []; anchorOff(false); } };
      if (last) { last.onfinish = opened; setTimeout(opened, last.effect.getComputedTiming().endTime + 300); }
      else anchorOff(false);
    } else {
      if (still()) { o.applyClosed(); anchorOff(false); return; }
      /* how much shorter the page gets once it's folded (measured, then put back before the screen updates) */
      var openTops = tops(list);
      o.applyClosed();
      var shutTops = tops(list);
      (o.holdOpen || o.applyOpen)();
      var delta = list.length ? openTops[0] - shutTops[0] : 0;
      st.closing = true;
      var runs2 = calm() ? [] : slide(list, before, -delta);
      var c2 = calm() ? null : clipWith(o.item, runs2.first);
      if (c2) runs2.push(c2);
      o.fadeEls.forEach(function (el, i) {
        /* the text fades for the whole of the slide, gently at first, so it is still faintly there as the card closes */
        runs2.push(el.animate([{ opacity: fades[i] }, { opacity: fades[i] * 0.55, offset: 0.5 }, { opacity: 0 }],
          { duration: calm() ? 320 : moveMs(Math.min(delta, Math.max(240, (window.innerHeight || 800) * 0.9)), 1), easing: 'linear', fill: 'forwards' }));
      });
      st.runs = runs2;
      var total = runs2.reduce(function (m, a) { return Math.max(m, a.effect.getComputedTiming().endTime); }, 0);
      var done = function () {
        if (!st.closing) return;
        st.closing = false;
        o.applyClosed();
        cancelAll(st);
        anchorOff(false);
      };
      if (runs2.length) {
        var lastC = runs2.filter(function (a) { return a.effect.getComputedTiming().endTime === total; })[0];
        lastC.onfinish = done;
        /* backstop: some phones skip animation events when the page is busy or in the background */
        setTimeout(function () { if (st.runs.indexOf(lastC) > -1) done(); }, total + 300);
      } else done();
    }
  }

  /* theme collapsibles + Bull Ring tab toggles */
  function isOpen(btn) { return btn.getAttribute('aria-expanded') === 'true'; }
  function mark(btn, panel, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel.hasAttribute('aria-hidden')) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    var blk = btn.closest('.brf-tab-min, .brf-rev-min');
    if (blk) blk.classList.toggle('is-open', open);
    var item = btn.closest('.product-block-list__item, .footer__block-item, .faq__item');
    if (item) item.classList.toggle('brf-acc-open', open);
  }
  function openStyles(panel) {
    /* the open look, whatever the stylesheet's closed look is (height 0, hidden, or display none) */
    unI(panel, LAYOUT);
    panel.style.setProperty('height', 'auto');
    panel.style.setProperty('visibility', 'visible');
    setI(panel, 'transition', 'none');
    if (getComputedStyle(panel).display === 'none') setI(panel, 'display', 'block');
  }
  function closedStyles(panel) {
    unI(panel, LAYOUT);
    setI(panel, 'transition', 'none');
    /* if the stylesheet doesn't fold it away by itself, fold it here */
    var cs = getComputedStyle(panel);
    if (cs.display !== 'none' && cs.visibility !== 'hidden' && curH(panel) > 0) {
      panel.style.setProperty('height', '0px');
      panel.style.setProperty('overflow', 'hidden');
      panel.style.setProperty('visibility', 'hidden');
    }
  }
  function toggle(btn, panel) {
    var opening = panel.__brfAcc && panel.__brfAcc.closing ? true : !isOpen(btn);
    var item = btn.closest('.product-block-list__item, .footer__block-item, .faq__item, .brf-tab-min, .brf-rev-min') || panel;
    fold({
      key: panel, item: item, opening: opening,
      fadeEls: [fadeTarget(panel)],
      applyOpen: function () { mark(btn, panel, true); openStyles(panel); },
      applyClosed: function () { mark(btn, panel, false); closedStyles(panel); },
      holdOpen: function () { mark(btn, panel, false); openStyles(panel); }
    });
  }

  /* <details> lists */
  function toggleDetails(det) {
    var sum = det.querySelector(':scope > summary');
    var opening = det.__brfAcc && det.__brfAcc.closing ? true : !det.open;
    fold({
      key: det, item: det, opening: opening,
      fadeEls: [].filter.call(det.children, function (c) { return c !== sum; }),
      applyOpen: function () { det.open = true; },
      applyClosed: function () { det.open = false; }
    });
  }

  /* ---------- 3. Tab bars: the box glides to the new tab's height, the new tab fades in ---------- */
  var tabState = null;
  function tabBox(tab) {
    var p = doc.getElementById(tab.getAttribute('aria-controls') || '');
    return p && p.parentElement;
  }
  function beforeTab(tab) {
    if (still()) return;
    var box = tabBox(tab); if (!box) return;
    if (box.__brfAccRun) { stop(box); unI(box, ['height', 'overflow', 'box-sizing']); }
    tabState = { box: box, h: curH(box), sel: tab.getAttribute('aria-selected') };
    requestAnimationFrame(function () { afterTab(tab); });
  }
  function afterTab(tab) {
    var st = tabState; tabState = null;
    if (!st || tab.getAttribute('aria-selected') !== 'true' || st.sel === 'true') return;
    var box = st.box;
    var panel = doc.getElementById(tab.getAttribute('aria-controls') || '');
    var to = curH(box);
    var runs = [];
    if (Math.abs(to - st.h) > 1) {
      setI(box, 'overflow', 'hidden');
      setI(box, 'box-sizing', 'border-box');
      var a = box.animate([{ height: st.h + 'px' }, { height: to + 'px' }], { duration: sizeMs(Math.abs(to - st.h), to > st.h), easing: EASE_OPEN });
      a.onfinish = function () { if (box.__brfAccRun && box.__brfAccRun[0] === a) box.__brfAccRun = null; unI(box, ['overflow', 'box-sizing']); };
      runs.push(a);
    }
    if (panel) runs.push(panel.animate([{ opacity: 0 }, { opacity: 1 }], { duration: calm() ? 240 : 260, easing: EASE_FADE_IN }));
    box.__brfAccRun = runs.length ? runs : null;
  }

  /* ---------- wiring (window, capture phase: runs before every other click handler) ---------- */
  function onClick(e) {
    if (e.defaultPrevented || e.button) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(TRIGGERS);
    if (btn && !btn.closest('[data-brf-noacc]') && !btn.disabled) {
      var panel = doc.getElementById(btn.getAttribute('aria-controls') || '');
      if (panel) {
        e.preventDefault();
        e.stopImmediatePropagation();
        toggle(btn, panel);
        return;
      }
    }
    var sum = t.closest('summary');
    if (sum && !t.closest('a, button, input, select, textarea, label')) {
      var det = sum.parentElement;
      if (det && det.tagName === 'DETAILS' && det.querySelector(':scope > summary') === sum && !det.closest('[data-brf-noacc]')) {
        e.preventDefault();
        toggleDetails(det);
        return;
      }
    }
    var tab = t.closest('[role="tab"]');
    if (tab && !tab.closest('[data-brf-noacc]') && !tab.classList.contains('pt-tab-btn')) beforeTab(tab);
  }
  function onKey(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var tab = t.closest('[role="tab"]');
    if (tab && /^(ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Home|End)$/.test(e.key) && !tab.closest('[data-brf-noacc]')) {
      /* the newly selected tab isn't known yet: watch the whole bar */
      if (still()) return;
      var list = tab.closest('[role="tablist"]'); if (!list) return;
      var box = tabBox(tab); if (!box) return;
      var h = curH(box), before = list.querySelector('[role="tab"][aria-selected="true"]');
      requestAnimationFrame(function () {
        var now = list.querySelector('[role="tab"][aria-selected="true"]');
        if (!now || now === before) return;
        tabState = { box: box, h: h, sel: 'false' };
        afterTab(now);
      });
    }
  }
  window.addEventListener('click', onClick, true);
  window.addEventListener('keydown', onKey, true);

  /* 2026-10-23: no grey tap flash on phones. iPhones paint a grey box over a tapped button for a moment, which read as a
     flicker before the tab opened. The fold-out headers now press cleanly (and answer the tap straight away). */
  (function () {
    var css = '.card__collapsible-button,.footer__title,.faq__question,.brf-tab-toggle,.brf-rev-toggle,summary,[role="tab"]'
      + '{-webkit-tap-highlight-color:transparent;touch-action:manipulation}';
    var st = doc.createElement('style');
    st.setAttribute('data-brf-acc', '');
    st.textContent = css;
    (doc.head || doc.documentElement).appendChild(st);
  })();

  /* ?brfacc=1 : small label confirming this file is running on this device */
  if (/[?&]brfacc=1/.test(location.search)) {
    var show = function () {
      var b = doc.createElement('div');
      b.setAttribute('data-brf-acc-badge', '');
      b.textContent = 'Smooth accordions v9 on · motion: ' + (calm() ? 'reduced (fade only)' : 'full');
      b.setAttribute('style', 'position:fixed;left:50%;top:10px;transform:translateX(-50%);z-index:2147483647;padding:8px 14px;border-radius:999px;background:rgba(29,29,31,.88);color:#fff;font:600 12px/1.3 -apple-system,system-ui,sans-serif;pointer-events:none');
      doc.body.appendChild(b);
    };
    if (doc.body) show(); else doc.addEventListener('DOMContentLoaded', show);
  }
})();
